export default {
  meta: {
    title: '中介管理'
  }
};

